/* ------------------------------------------------------------------
 *  SNSに関する関数
--------------------------------------------------------------------- */

// まとめて表示
function appendSnsBtns() {
  // line
  const { title } = document;
  const linecode = `<li class='lineBox'><a href='https://line.me/R/msg/text/?${title}  ${window.location.href}' class='p_snsIcon isLine'></a></li>`;
  setTimeout(() => {
    $("#jsShare").append(linecode);
  }, 2000);
  // twiter
  const twittercode = `<li class='twBox'><a href='twitter://post?message=${title}${window.location.href}&via=activo_npo' data-lang='ja' class='p_snsIcon isTwitter'></a></li>`;
  setTimeout(() => {
    $("#jsShare").append(twittercode);
  }, 2000);
  // facebook
  const facebookcode = `<li class='fbBox'><a class='jsFacebookTemporary p_snsIcon isFacebook' target='_blank' href='https://www.facebook.com/share.php?u=${window.location.href}' ></a></li>`;
  setTimeout(() => {
    $("#jsShare").append(facebookcode);
  }, 2000);
}

// Twitterのjsタグ
const TW_JS =
  "<script>function callAfterTwitterInitialization(callback){if(typeof twttr !== 'undefined'){callback();} else {setTimeout(function(){callAfterTwitterInitialization(callback);}, 100);}}!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+'://platform.twitter.com/widgets.js';fjs.parentNode.insertBefore(js,fjs);}else{callAfterTwitterInitialization(function(){twttr.widgets.load();});}}(document, 'script', 'twitter-wjs');</script>";
// 参考：http://mementoo.info/archives/1853

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export { appendSnsBtns, TW_JS };
